module.exports = __webpack_public_path__ + "img/code2.ed063281.png";